// extracted by mini-css-extract-plugin
export default {"wrap":"wrap___SA5rd","errorText":"errorText___tUGlD"};